import multiApiClient from "./base";

export const DebugApi = {
  getStatus: () => multiApiClient.get("/health/debug/status"),

  triggerSentryCrash: () => multiApiClient.post("/health/debug/sentry/crash"),

  triggerSentryLogError: () =>
    multiApiClient.post("/health/debug/sentry/log-error"),

  triggerSentryCaptureMessage: (message) =>
    multiApiClient.post("/health/debug/sentry/capture-message", null, {
      params: { message },
    }),

  triggerPrometheusTest: () =>
    multiApiClient.post("/health/debug/prometheus/test"),
};
